function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#202144"
}, /*#__PURE__*/React.createElement("path", {
  d: "m4.48 10.91c0 .1-.14.1-.18 0l-4.3-10.38h2.88l1.91 4.81 2.21-5c0-.08.09-.08.12 0l2.31 5 1.82-4.81h2.75l-4.24 10.38c0 .12-.12.12-.18 0l-2.58-5.51z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m14.33.48h7.5v2.36h-4.66v1.94h3.92v2.22h-3.92v1.48h4.83v2.31h-7.67z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m23.26.48h4.27a4.94 4.94 0 0 1 5.19 5.18 4.9 4.9 0 0 1 -5.19 5.13h-4.27zm4 8a2.56 2.56 0 0 0 2.69-2.81 2.56 2.56 0 0 0 -2.69-2.8h-1.11v5.6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m32.65 5.66a5.31 5.31 0 0 1 5.5-5.25 5.31 5.31 0 0 1 5.5 5.25 5.51 5.51 0 0 1 -11 0zm8.2 0a2.7 2.7 0 1 0 -5.4 0 2.7 2.7 0 1 0 5.4 0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m44.91.48h4.09a4.94 4.94 0 0 1 5.19 5.18 4.9 4.9 0 0 1 -5.19 5.13h-4.09zm3.77 8a2.56 2.56 0 0 0 2.68-2.81 2.56 2.56 0 0 0 -2.68-2.8h-1v5.6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m65.3 2.79h-3.16v-2.31h9.46v2.31h-3.15v8h-3.15z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m56.3 10.79h-2.57l5-10.44c0-.11.14-.11.18 0l5 10.44h-2.74l-2.48-5.56z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m60.95 7.74h-4.51l-1.14 2.05h6.85z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m72.42 10.79h-2.57l5-10.44c0-.11.14-.11.18 0l5 10.44h-2.74l-2.48-5.56z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m77.07 7.74h-4.51l-1.14 2.05h6.85z"
}));

var SvgLogoWdd = function SvgLogoWdd(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 11,
    viewBox: "0 0 80 11",
    width: 80,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoWdd, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-WDD.7aed52c1.svg";
export { ForwardRef as ReactComponent };